<template>
    <div>
        <div>
            <label class="main-text-color">{{ $t('layout.config.widgetTableContentFontSize') }}</label>
        </div>
        <el-input-number
            v-model="model"
            :max="optionConfigs.WidgetTableContentFontSize.max"
            :min="optionConfigs.WidgetTableContentFontSize.min"
            :step="optionConfigs.WidgetTableContentFontSize.step"
            size="small"
            placeholder="0"
        />
    </div>
</template>

<script>
import { InputNumber } from 'element-ui'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import { widgetTableContentFontSize } from '@/composables/globalData/useLayouts'

export default {
    components: {
        [InputNumber.name]: InputNumber,
    },
    props: {
        value: {
            type: [ Number, String ],
            required: false
        }
    },
    computed: {
        optionConfigs () {
            return optionConfigs
        },
        hasOwnValue () {
            return this.value !== undefined
        },
        layoutConfig () {
            return widgetTableContentFontSize.value.fontSize
        },
        stringValue () {
            if (this.hasOwnValue) {
                return this.value
            } else {
                return this.layoutConfig
            }
        },
        model: {
            get () {
                return this.stringValueToNumber(this.stringValue)
            },
            set (val) {
                this.$emit('input', this.numberValueToString(val))
            }
        }
    },
    methods: {
        stringValueToNumber (value) {
            return parseInt(value.replace('px', ''))
        },
        numberValueToString (value) {
            return `${value}px`
        }
    }
}
</script>
